import { PageId } from 'constants/pages'
import { getHasBasicSubscription } from 'helpers/getHasBasicSubscription'
import { getIntellioResumeTarget } from 'helpers/getIntellioResumeTarget'
import type { TStep } from 'src/types'
import { useZustandGlobalStore } from 'zustandGlobalStore'

// Paid and registered intl_2lw users resume on the LearnWorlds redirect page
// instead of the report page that follows it, even after they already left for
// the platform once.
export const getIntellio2LwResumeTarget = (pages: TStep[]): PageId => {
  const resumeTarget = getIntellioResumeTarget({
    pages,
    pageIds: {
      certificate: PageId.CERTIFICATE_INTL_2LW,
      nameEntry: PageId.NAME_ENTRY_INTL_2LW,
      offer: PageId.OFFER_INTL_2LW,
      registration: PageId.REGISTRATION_INTL_2LW,
      report: PageId.REPORT_INTL_2LW,
    },
  })

  if (resumeTarget !== PageId.REPORT_INTL_2LW) return resumeTarget

  const { lead } = useZustandGlobalStore.getState()
  const hasSubscription = getHasBasicSubscription(lead?.subscriptions || null)
  const hasAccount = !!lead?.firebaseToken

  return hasSubscription && hasAccount
    ? PageId.LEARNWORLDS_REDIRECT_INTL_2LW
    : resumeTarget
}
